import React from "react";
import { Col, Row } from "react-bootstrap";

const RoofSloopCase = ({ caseData, buildingType = "CS" }) => {
  if (!caseData) return null;

  const { caseTypeCode } = caseData;

  // Images per case for different building types
  const caseImages = {
    CS: {
      C1: "/assets/img/halleysblue/clear_span_roof_images/case_01_model.jpg",
      C2: "/assets/img/halleysblue/clear_span_roof_images/case_02_model.jpg",
      C3: "/assets/img/halleysblue/clear_span_roof_images/case_03_model.jpg",
      C4: "/assets/img/halleysblue/clear_span_roof_images/case_04_model.jpg",
    },
    MSB: {
      M1: "/assets/img/halleysblue/double_slope_multi_span_Building/double_slope_multi_span_Building_1.jpg",
      M2: "/assets/img/halleysblue/double_slope_multi_span_Building/double_slope_multi_span_Building_2.jpg",
      M3: "/assets/img/halleysblue/double_slope_multi_span_Building/double_slope_multi_span_Building_3.jpg",
      M4: "/assets/img/halleysblue/double_slope_multi_span_Building/double_slope_multi_span_Building_4.jpg",
    }
  };

  // Input positions per case for different building types
  const caseInputs = {
    CS: {
     C1: [
      {
        id: 1,
        top: "19%",
        left: "31%",
        value: "ridgeDistanceLeft",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 2,
        top: "19%",
        left: "60%",
        value: "ridgeDistanceRight",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 3,
        top: "23.8%",
        left: "27%",
        value: "leftSlope",
        width: "5%",
        height: "2.2%",
        borderColor: "green",
      },
      {
        id: 4,
        top: "23.8%",
        left: "68%",
        value: "rightSlope",
        width: "5%",
        height: "2.2%",
        borderColor: "green",
      },
      {
        id: 5,
        top: "44%",
        left: "13%",
        value: "eaveHeightLSW",
        width: "7%",
        height: "4%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 6,
        top: "44%",
        left: "79.2%",
        value: "eaveHeightRSW",
        width: "7%",
        height: "4%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 7,
        top: "49%",
        left: "21.5%",
        value: "clearHeightLSW",
        width: "6%",
        height: "3%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 8,
        top: "49%",
        left: "71.5%",
        value: "clearHeightRSW",
        width: "6%",
        height: "3%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 9,
        top: "45%",
        left: "84.4%",
        value: "ridgeHeight",
        width: "7%",
        height: "3%",
        rotation: -90,
        borderColor: "red",
      },
      {
        id: 10,
        top: "73%",
        left: "47%",
        value: "width",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 6,
        top: "59%",
        left: "16.5%",
        rotation: -90,
        value: "lswWallHeight",
        width: "6%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 6,
        top: "58%",
        left: "77.2%",
        rotation: -90,
        value: "rswWallHeight",
        width: "6%",
        height: "3%",
        borderColor: "green",
      },
    ],
    C2: [
      {
        id: 1,
        top: "14%",
        left: "32%",
        value: "ridgeDistanceLeft",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 2,
        top: "14%",
        left: "60%",
        value: "ridgeDistanceRight",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 3,
        top: "18.7%",
        left: "27%",
        value: "leftSlope",
        width: "5%",
        height: "2.2%",
        borderColor: "red",
      },
      {
        id: 4,
        top: "18.7%",
        left: "68%",
        value: "rightSlope",
        width: "5%",
        height: "2.2%",
        borderColor: "red",
      },
      {
        id: 5,
        top: "46%",
        left: "13%",
        value: "eaveHeightLSW",
        width: "7%",
        height: "4%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 6,
        top: "44%",
        left: "79%",
        value: "eaveHeightRSW",
        width: "7%",
        height: "4%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 7,
        top: "49%",
        left: "21.5%",
        value: "clearHeightLSW",
        width: "6%",
        height: "3%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 8,
        top: "49%",
        left: "71.9%",
        value: "clearHeightRSW",
        width: "6%",
        height: "3%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 9,
        top: "45%",
        left: "84.4%",
        value: "ridgeHeight",
        width: "7%",
        height: "3%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 10,
        top: "73%",
        left: "46%",
        value: "width",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 6,
        top: "59%",
        left: "16.5%",
        rotation: -90,
        value: "lswWallHeight",
        width: "6%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 6,
        top: "59%",
        left: "77.2%",
        rotation: -90,
        value: "rswWallHeight",
        width: "6%",
        height: "3%",
        borderColor: "green",
      },
    ],
    C3: [
      {
        id: 1,
        top: "10%",
        left: "30%",
        value: "ridgeDistanceLeft",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 2,
        top: "10%",
        left: "55%",
        value: "ridgeDistanceRight",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 3,
        top: "13.6%",
        left: "26%",
        value: "leftSlope",
        width: "5%",
        height: "2.4%",
        borderColor: "red",
      },
      {
        id: 4,
        top: "13.6%",
        left: "69%",
        value: "rightSlope",
        width: "5%",
        height: "2.4%",
        borderColor: "red",
      },
      {
        id: 5,
        top: "41%",
        left: "14%",
        value: "eaveHeightLSW",
        width: "7%",
        height: "4%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 6,
        top: "41%",
        left: "80.6%",
        value: "eaveHeightRSW",
        width: "7%",
        height: "4%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 7,
        top: "49%",
        left: "22.2%",
        value: "clearHeightLSW",
        width: "6%",
        height: "3%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 8,
        top: "49%",
        left: "69.8%",
        value: "clearHeightRSW",
        width: "6%",
        height: "3%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 9,
        top: "45%",
        left: "85.6%",
        value: "ridgeHeight",
        width: "7%",
        height: "3%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 10,
        top: "74%",
        left: "47%",
        value: "width",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 6,
        top: "56%",
        left: "17.2%",
        rotation: -90,
        value: "lswWallHeight",
        width: "6%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 6,
        top: "56%",
        left: "77.7%",
        rotation: -90,
        value: "rswWallHeight",
        width: "6%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 9,
        top: "69.4%",
        left: "28%",
        rotation: 0,
        value: "width1",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 9,
        top: "69.4%",
        left: "59%",
        rotation: 0,
        value: "width2",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
    ],
   
    C4: [
      {
        id: 1,
        top: "14%",
        left: "26%",
        value: "ridgeDistanceLeft",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 2,
        top: "14%",
        left: "53%",
        value: "ridgeDistanceRight",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 3,
        top: "19%",
        left: "25%",
        value: "leftSlope",
        width: "5%",
        height: "2.2%",
        borderColor: "red",
      },
      {
        id: 4,
        top: "18.7%",
        left: "66%",
        value: "rightSlope",
        width: "5%",
        height: "2.2%",
        borderColor: "red",
      },
      {
        id: 5,
        top: "40%",
        left: "11.2%",
        value: "eaveHeightLSW",
        width: "7%",
        height: "4%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 6,
        top: "40%",
        left: "77.6%",
        value: "eaveHeightRSW",
        width: "7%",
        height: "4%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 7,
        top: "45%",
        left: "19.8%",
        value: "clearHeightLSW",
        width: "6%",
        height: "3%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 8,
        top: "46%",
        left: "70.6%",
        value: "clearHeightRSW",
        width: "6%",
        height: "3%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 9,
        top: "41%",
        left: "83%",
        value: "ridgeHeight",
        width: "7%",
        height: "3%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 10,
        top: "71%",
        left: "44%",
        value: "width",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 6,
        top: "54%",
        left: "14.8%",
        rotation: -90,
        value: "lswWallHeight",
        width: "6%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 6,
        top: "54%",
        left: "75.5%",
        rotation: -90,
        value: "rswWallHeight",
        width: "6%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 9,
        top: "66.4%",
        left: "28%",
        rotation: 0,
        value: "width1",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 9,
        top: "66.4%",
        left: "56%",
        rotation: 0,
        value: "width2",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
    ],
    },
    MSB: {
     M1: [
      {
        id: 1,
        top: "13%",
        left: "31%",
        value: "ridgeDistanceLeft",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 2,
        top: "13%",
        left: "60%",
        value: "ridgeDistanceRight",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 3,
        top: "18.6%",
        left: "24%",
        value: "leftSlope",
        width: "5%",
        height: "2.2%",
        borderColor: "green",
      },
      {
        id: 4,
        top: "18.6%",
        left: "68%",
        value: "rightSlope",
        width: "5%",
        height: "2.2%",
        borderColor: "green",
      },
      {
        id: 5,
        top: "43%",
        left: "9.7%",
        value: "eaveHeightLSW",
        width: "7%",
        height: "4%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 6,
        top: "42%",
        left: "81.4%",
        value: "eaveHeightRSW",
        width: "7%",
        height: "4%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 7,
        top: "48%",
        left: "18.5%",
        value: "clearHeightLSW",
        width: "6%",
        height: "3%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 8,
        top: "48%",
        left: "72.6%",
        value: "clearHeightRSW",
        width: "6%",
        height: "3%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 9,
        top: "43%",
        left: "86.4%",
        value: "ridgeHeight",
        width: "7%",
        height: "3%",
        rotation: -90,
        borderColor: "red",
      },
      {
        id: 10,
        top: "74%",
        left: "46%",
        value: "width",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 6,
        top: "58%",
        left: "12.8%",
        rotation: -90,
        value: "lswWallHeight",
        width: "6%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 6,
        top: "55%",
        left: "78.2%",
        rotation: -90,
        value: "rswWallHeight",
        width: "6%",
        height: "3%",
        borderColor: "green",
      },
      
     
    ],
    M2:  [
      {
        id: 1,
        top: "8%",
        left: "31%",
        value: "ridgeDistanceLeft",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 2,
        top: "8%",
        left: "60%",
        value: "ridgeDistanceRight",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 3,
        top: "12.9%",
        left: "24%",
        value: "leftSlope",
        width: "5%",
        height: "2.2%",
        borderColor: "red",
      },
      {
        id: 4,
        top: "12.9%",
        left: "68%",
        value: "rightSlope",
        width: "5%",
        height: "2.2%",
        borderColor: "red",
      },
      {
        id: 5,
        top: "43%",
        left: "9.7%",
        value: "eaveHeightLSW",
        width: "7%",
        height: "4%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 6,
        top: "42%",
        left: "81.4%",
        value: "eaveHeightRSW",
        width: "7%",
        height: "4%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 7,
        top: "48%",
        left: "18.5%",
        value: "clearHeightLSW",
        width: "6%",
        height: "3%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 8,
        top: "48%",
        left: "72.6%",
        value: "clearHeightRSW",
        width: "6%",
        height: "3%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 9,
        top: "43%",
        left: "86.4%",
        value: "ridgeHeight",
        width: "7%",
        height: "3%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 10,
        top: "74%",
        left: "46%",
        value: "width",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 6,
        top: "58%",
        left: "12.8%",
        rotation: -90,
        value: "lswWallHeight",
        width: "6%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 6,
        top: "55%",
        left: "78.2%",
        rotation: -90,
        value: "rswWallHeight",
        width: "6%",
        height: "3%",
        borderColor: "green",
      },
     
     
    ],
    M3: [
      {
        id: 1,
        top: "8%",
        left: "27%",
        value: "ridgeDistanceLeft",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 2,
        top: "8%",
        left: "54%",
        value: "ridgeDistanceRight",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 3,
        top: "11.9%",
        left: "22%",
        value: "leftSlope",
        width: "5%",
        height: "2.2%",
        borderColor: "red",
      },
      {
        id: 4,
        top: "11.9%",
        left: "69%",
        value: "rightSlope",
        width: "5%",
        height: "2.2%",
        borderColor: "red",
      },
      {
        id: 5,
        top: "43%",
        left: "9.7%",
        value: "eaveHeightLSW",
        width: "7%",
        height: "4%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 6,
        top: "42%",
        left: "81.4%",
        value: "eaveHeightRSW",
        width: "7%",
        height: "4%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 7,
        top: "48%",
        left: "18.5%",
        value: "clearHeightLSW",
        width: "6%",
        height: "3%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 8,
        top: "48%",
        left: "69.6%",
        value: "clearHeightRSW",
        width: "6%",
        height: "3%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 9,
        top: "43%",
        left: "86.4%",
        value: "ridgeHeight",
        width: "7%",
        height: "3%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 10,
        top: "79.4%",
        left: "45%",
        value: "width",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 6,
        top: "57%",
        left: "12.8%",
        rotation: -90,
        value: "lswWallHeight",
        width: "6%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 6,
        top: "57%",
        left: "78.2%",
        rotation: -90,
        value: "rswWallHeight",
        width: "6%",
        height: "3%",
        borderColor: "green",
      },
    
        {
        id: 9,
        top: "74.2%",
        left: "27%",
        rotation: 0,
        value: "width1",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 9,
        top: "74.2%",
        left: "56%",
        rotation: 0,
        value: "width2",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
     
    ],
   
    M4:  [
      {
        id: 1,
        top: "13%",
        left: "27%",
        value: "ridgeDistanceLeft",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 2,
        top: "13%",
        left: "54%",
        value: "ridgeDistanceRight",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 3,
        top: "18.9%",
        left: "24%",
        value: "leftSlope",
        width: "5%",
        height: "2.2%",
        borderColor: "red",
      },
      {
        id: 4,
        top: "18.5%",
        left: "69%",
        value: "rightSlope",
        width: "5%",
        height: "2.2%",
        borderColor: "red",
      },
      {
        id: 5,
        top: "43%",
        left: "9.7%",
        value: "eaveHeightLSW",
        width: "7%",
        height: "4%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 6,
        top: "42%",
        left: "81.4%",
        value: "eaveHeightRSW",
        width: "7%",
        height: "4%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 7,
        top: "48%",
        left: "18.5%",
        value: "clearHeightLSW",
        width: "6%",
        height: "3%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 8,
        top: "48%",
        left: "72.6%",
        value: "clearHeightRSW",
        width: "6%",
        height: "3%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 9,
        top: "43%",
        left: "86.4%",
        value: "ridgeHeight",
        width: "7%",
        height: "3%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 10,
        top: "77.4%",
        left: "45%",
        value: "width",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 6,
        top: "57%",
        left: "12.8%",
        rotation: -90,
        value: "lswWallHeight",
        width: "6%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 6,
        top: "55%",
        left: "78.2%",
        rotation: -90,
        value: "rswWallHeight",
        width: "6%",
        height: "3%",
        borderColor: "green",
      },
    
        {
        id: 9,
        top: "72.4%",
        left: "27%",
        rotation: 0,
        value: "width1",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 9,
        top: "72.4%",
        left: "56%",
        rotation: 0,
        value: "width2",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
     
    ],
    }
  };

  // Get the appropriate image and inputs based on building type
  const getImageSrc = () => {
    const buildingImages = caseImages[buildingType] || caseImages.CS;
    return buildingImages[caseTypeCode] || "/assets/img/placeholder.jpg";
  };

  const getInputs = () => {
    const buildingInputs = caseInputs[buildingType] || caseInputs.CS;
    return buildingInputs[caseTypeCode] || [];
  };

  const imageSrc = getImageSrc();
  const inputs = getInputs();

  return (
    <Row className="justify-content-center">
      <Col xs={12} className="d-flex justify-content-center">
        <div
          style={{ position: "relative", width: "100%", maxWidth: "1400px" }}
        >
          {/* Case Image */}
          <img
            src={imageSrc}
            alt={`${caseTypeCode} - ${buildingType}`}
            style={{ width: "100%", height: "auto", display: "block" }}
            onError={(e) => {
              e.target.src = "/assets/img/placeholder.jpg";
            }}
          />

          {/* Overlay Inputs */}
          {inputs.map((inp) => (
            <input
              key={inp.id}
              type="text"
              name={inp.value}
              value={caseData[inp.value] || ""}
              disabled
              style={{
                position: "absolute",
                top: inp.top,
                left: inp.left,
                transform: `rotate(${inp.rotation || 0}deg)`,
                width: inp.width,
                height: inp.height,
                padding: "4px",
                border: `1px solid ${inp.borderColor || "#333"}`,
                borderRadius: "4px",
                fontSize: "0.8rem",
                backgroundColor: "white",
                textAlign: "center",
              }}
            />
          ))}
        </div>
      </Col>
    </Row>
  );
};

export default RoofSloopCase;